import formData from "./formData";

const {
  formField: {
    firstName,
    middleName,
    lastName,
    mmcId,
    rating,
    vessel,
    fromDate,
    toDate,
    nearMissSubmissions,
    lostTimeInjuries,
    restrictedWorkInjuries,
    medicalTreatmentInjuries,
    scores,
    assessor1,
    assessor1Comment,
    assessor2,
    assessor2Comment,
    finalReviewer,
    finalReviewerComment,
    evaluatee,
    evaluateeComment,
    status,
    readyForPromotion,
    hasPreviousWarnings,
    reviewedWithMariner,
  },
} = formData;

const initialValues = {
  [firstName.name]: "",
  [middleName.name]: "",
  [lastName.name]: "",
  [mmcId.name]: "",
  [rating.name]: undefined,
  [vessel.name]: undefined,
  [fromDate.name]: "",
  [toDate.name]: "",
  [nearMissSubmissions.name]: "",
  [lostTimeInjuries.name]: "",
  [restrictedWorkInjuries.name]: "",
  [medicalTreatmentInjuries.name]: "",
  [scores.name]: [],
  [assessor1.name]: undefined,
  [assessor1Comment.name]: "",
  [assessor2.name]: undefined,
  [assessor2Comment.name]: "",
  [finalReviewer.name]: undefined,
  [finalReviewerComment.name]: "",
  [evaluatee.name]: undefined,
  [evaluateeComment.name]: "",
  [status.name]: "",
  [readyForPromotion.name]: undefined,
  [hasPreviousWarnings.name]: undefined,
  [reviewedWithMariner.name]: undefined,
};

export default initialValues;
